import React, { useState, useEffect } from 'react'
import { Button } from 'semantic-ui-react'

const CustomPreview = ({ args }) => {
  const { html } = args
  const [darkMode, setDarkMode] = useState(false)
  const [previewHTML, setPreviewHTML] = useState()

  const darkModeScript = '<script src="https://app-rsrc.getbee.io/public/resources/preview/dark-mode/dark-mode.min.js"></script>'

  useEffect(() => {
    const mergedHTML = html.replace('</body>', `</body>${darkModeScript}`)
    setPreviewHTML(mergedHTML)
  }, [html])


  const toggleDarkMode = () => {
    const nextDarkMode = !darkMode
    const iframeEl = document.getElementById('iframe')
    /* eslint-disable no-unused-expressions */
    iframeEl?.contentWindow?.postMessage(nextDarkMode ? 'setDarkMode' : 'revertDarkMode', '*')
    setDarkMode(nextDarkMode)
  }

  return (
    <div>
      <Button onClick={toggleDarkMode}>Toggle Dark Mode</Button>
      {
        previewHTML && (
          <iframe id="iframe" srcDoc={previewHTML}></iframe>
        )
      }
    </div>
  )
}

export default CustomPreview
